import React from 'react';
import { Iffy, luxColors } from '@alucio/lux-ui';
import BandwidthWarning from '../BandwidthWarning/BandwidthWarning';
import useIsTrackSwitchedOff from '../../../src/hooks/useIsTrackSwitchedOff/useIsTrackSwitchedOff';
import usePublications from '../../../src/hooks/usePublications/usePublications';
import useTrack from '../../../src/hooks/useTrack/useTrack';
import ParticipantPlaceholder from '../ParticipantInfo/ParticipantPlaceholder/ParticipantPlaceholder';
export default function MainParticipantInfo({ participant, children }) {
    const publications = usePublications(participant);
    const videoPublication = publications.find(p => p.trackName.includes('camera'));
    const screenSharePublication = publications.find(p => p.trackName.includes('screen'));
    const isVideoEnabled = Boolean(videoPublication);
    const videoTrack = useTrack(screenSharePublication || videoPublication);
    const isVideoSwitchedOff = useIsTrackSwitchedOff(videoTrack);
    return (React.createElement("div", { "data-cy-main-participant": true, style: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            gridArea: 'participantList',
            width: '100%',
            height: '100%',
            backgroundColor: luxColors.contentPanelBackground.primary,
        } },
        React.createElement("div", { style: {
                position: 'absolute',
                zIndex: 1,
                height: '100%',
                padding: '0.4em',
                width: '100%',
            } }),
        isVideoSwitchedOff && React.createElement(BandwidthWarning, null),
        React.createElement(Iffy, { is: isVideoEnabled }, children),
        React.createElement(Iffy, { is: !isVideoEnabled },
            React.createElement(ParticipantPlaceholder, { placeholderIconStyle: { height: 60, width: 60 } }))));
}
//# sourceMappingURL=MainParticipantInfo.js.map